import orderMerge from '../../services/orderMerge'

export default {
  dateDiff(date1, date2) {
    return Math.round(
      Math.abs(date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24),
    );
  },
  orderWebsiteLink(order) {
    const num = order.num || order.name
    switch (order.websiteName) {
      case 'workarea':
        return `https://workarea.andymark.com/admin/orders/${num}`
      case 'shopify':
        let id = orderMerge.mergeField(order.id)
        id = id.includes('/') ? id.split('/').at(-1) : id

        if (num.startsWith('D')) {
          return `https://admin.shopify.com/store/2ca7d3-42/draft_orders/${id}`
        } else {
          return `https://admin.shopify.com/store/2ca7d3-42/orders/${id}`
        }
      default:
        console.warn('!!! Fetching return viewing URL is not supported for this source!')
        return
    }
  }
};



// WEBPACK FOOTER //
// /src/helpers/services/common.js